module.exports = __webpack_public_path__ + "img/2.a049866.png";